import * as e from "react";
import i from "../lib/IconBase.es.js";
import m from "../defs/PushPinSimpleSlash.es.js";
const o = e.forwardRef((s, a) => /* @__PURE__ */ e.createElement(i, { ref: a, ...s, weights: m }));
o.displayName = "PushPinSimpleSlashIcon";
const n = o;
export {
  n as PushPinSimpleSlash,
  o as PushPinSimpleSlashIcon
};
